













































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import IndustryDto from '@/models/Industries/IndustryDto';
import UpdateIndustryRequest from '@/models/Industries/UpdateIndustryRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'IndustryEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new IndustryDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentIndustry));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateIndustryRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    await AgencySettingsModule.editIndustry(request)
    this.dialog = false;
  }
}
